export enum UserRole {
  SUPER_ADMIN = "super admin",
  ADMIN = "admin",
  USER = "user",
}
